// import {
//   faCircleInfo,
//   faRightFromBracket,
//   faUser,
// } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { handleClearCookie } from "../../../utils/helper";
import UserInfoContext from "../../../utils/userInfoContext";
import { getAvatarData } from "../../../utils/avatarUtils";
import { truncateUsername, getUsernameDisplay } from "../../../utils/usernameUtils";
import Button from "../../Elements/Button";
import TermsModals from "../../Modals/TermsModals";
import MyProfileModal from "../../Modals/profileModals/MyProfileModal";
import FallbackLimitModal from "../../Modals/profileModals/FallbackLimitModal";
import "./header.css";

const Header = ({ heading, currentUser, trueUser, active, setActive }) => {
  const { profileData, userInfoData, setShowCreateTerms, openPrivacyNotice, setOpenPrivacyNotice, refetchUserProfile } = useContext(UserInfoContext);
  const [profileModalStaus, setProfileModalStaus] = useState(false);
  const isProfileModalOpened = localStorage.getItem('modalOpen')
  const { pathname } = useLocation();
  const isStatsPage = pathname.includes('-stats');
  // Dismissible nudge -- re-appears on the next stats-page visit if still unresolved,
  // rather than being tracked as permanently seen the way the first-run modal is.
  const [showFallbackLimitModal, setShowFallbackLimitModal] = useState(false);

  useEffect(() => {
    setShowFallbackLimitModal(isStatsPage && !!profileData?.fallback_limit_reached);
  }, [isStatsPage, profileData?.fallback_limit_reached])

  const createNewAfterTermsRef = useRef(false);

  const handleTermsAccepted = () => {
    if (!createNewAfterTermsRef.current) return;
    createNewAfterTermsRef.current = false;
    window.location = "/kdfs/new";
  }

  const handleCreateNew = () => {
    if (userInfoData?.tos_accepted_date == null) {
      createNewAfterTermsRef.current = true;
      setShowCreateTerms(true)
    } else {
      window.location = "/kdfs/new"
    }
  }

  useEffect(() => {
    if ((isProfileModalOpened == 'false' || isProfileModalOpened == null) && userInfoData && profileData) {
      // First-run: brand new account, profile never completed. A geolocation provider
      // is no longer part of this check -- Session#process falls back to a house
      // account when none is configured, so nobody needs to set one up just to use
      // location tracking (see Geo::Resolver).
      const isIncompleteNewProfile =
        (userInfoData?.privacy_accepted == null || !userInfoData?.privacy_accepted) &&
        (profileData?.first_name == null || !profileData?.first_name);

      if (isIncompleteNewProfile) {
        setProfileModalStaus(true)
        localStorage.setItem("modalOpen", true)
      }
    }
  }, [userInfoData, profileData])

  useEffect(() => {
    if (userInfoData?.privacy_reaccept_required) {
      setOpenPrivacyNotice(true)
    } else if (userInfoData?.terms_reaccept_required) {
      setShowCreateTerms(true)
    }
  }, [userInfoData?.privacy_reaccept_required, userInfoData?.terms_reaccept_required])

  // Get avatar data (initial and color) from user's first name
  const avatarData = getAvatarData(profileData?.first_name || profileData?.name || currentUser?.name || currentUser?.email || '');
  
  // Get truncated username for display
  const firstNameDisplay = getUsernameDisplay(profileData?.first_name || '');

  return (
    <header className="main-header">
      <Navbar expand="lg" className="bg-body-tertiary top-header-bg">
        <Container fluid className="kdf-setting-header-h">
          <Navbar.Brand>
                <a
                  className=" me-3 menu-toggle"
                  onClick={() => setActive(!active)}
                  aria-label="Toggle sidebar"
                  >
                  {active ? "" : ""} 
                  <img src="/icons/menu.svg"/>
                </a>
            {heading?.toLowerCase() == "kdfs" ? (
              <div className="d-flex align-items-center create-new-kdf">
                {/* <h2
               className="me-4 mb-0" >
                 {heading}
               </h2> */}
               {/* Toggle button */}
                <Button
                  classList={"success"}
                  addonClass="d-flex ml-4"
                  onClick={() => handleCreateNew()}
                  text={"Create New"}
                  icon={<img src="/icons/add_2.svg" alt="" className="me-2 create-kdf-icon" />}
                />
              </div>
            ) : (
              <h2 className="m-0">{heading} </h2>
            )}

          </Navbar.Brand>
          <Nav
            className="my-2 my-lg-0"
            style={{ maxHeight: "100px" }}
            navbarScroll
          >
            <NavDropdown
            className="profile-dropdown-container"
              title={
                <>
                <div className="user-imgs-container">
                  <div 
                    className="user-imgs user-avatar-initial"
                    style={{ backgroundColor: avatarData.color }}
                    aria-label={`${avatarData.initial} avatar`}
                  >
                    {avatarData.initial}
                  </div>
                  <span 
                    className="mx-2 user-name-header"
                    title={firstNameDisplay.needsTruncation ? firstNameDisplay.full : ''}
                  >
                    {firstNameDisplay.truncated}{" "}
                  </span>
                  <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="none">
                    <path d="M13.6663 1.33333L6.99967 8L0.333009 1.33334L1.51634 0.150002L6.99967 5.63333L12.483 0.150001L13.6663 1.33333Z" fill="#333333"/>
                  </svg>
                  </span>
                </div>
                </>
              }
              id="navbarScrollingDropdown"
            >
              <NavDropdown.Item className="profile-drop" href="/profile">
                {/* <FontAwesomeIcon icon={faUser} className="" />  */}
                <img src="/icons/account_circle.svg"/>
                My Profile
              </NavDropdown.Item>
              <NavDropdown.Item className="profile-drop" href="/customizations">
                {/* <FontAwesomeIcon icon={faCircleInfo} className="" />{" "} */}
                <img src="/icons/settings_applications.svg"/>
                Customizations
              </NavDropdown.Item>
              <NavDropdown.Item
                className="profile-drop"
                onClick={handleClearCookie}
              >
              <img src="/icons/logout.svg"/>
                Logout
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Container>
      </Navbar>
      <MyProfileModal
        profileModalStaus={profileModalStaus}
        setProfileModalStaus={setProfileModalStaus}
        setOpenTerms={setOpenPrivacyNotice}
      />
      <FallbackLimitModal
        show={showFallbackLimitModal}
        onClose={() => setShowFallbackLimitModal(false)}
      />
      <TermsModals refetch={refetchUserProfile || (() => {})} openTerms={openPrivacyNotice} setOpenTerms={setOpenPrivacyNotice} onTermsAccepted={handleTermsAccepted} />
    </header>
  );
};

export default Header;
